import React, { useState } from "react";
import Dashboard2 from "./components/dashboard2";
import Recordings from "./components/Recordings";
import Community from "./components/community";
import Login from "./components/Login";
import HeatMapView from "./components/HeatMapView";
import LocationView from "./components/LocationView";
import "./App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState("Dashboard2");

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleNavigation = (page) => {
    setCurrentPage(page);
  };

  return (

     <div className="app-container">
    {window.location.pathname === "/location" ? (
      <LocationView />
    ) : isLoggedIn ? (
      <>
          <div className="sidebar">
            <h2>Admin Panel</h2>
            <ul>
              <li
                className={currentPage === "Dashboard2" ? "active" : ""}
                onClick={() => handleNavigation("Dashboard2")}
              >
                Dashboard
              </li>
              <li
                className={currentPage === "Recordings" ? "active" : ""}
                onClick={() => handleNavigation("Recordings")}
              >
                Recordings
              </li>
              <li
                className={currentPage === "Community" ? "active" : ""}
                onClick={() => handleNavigation("Community")}
              >
                Community
              </li>
              <li
                className={currentPage === "Map" ? "active" : ""}
                onClick={() => handleNavigation("Map")}
              >
                Map
              </li>
              <li
                className={currentPage === "LocationView" ? "active" : ""}
                onClick={() => handleNavigation("LocationView")}
              >
                LocationView
              </li>
            </ul>
          </div>
          <div className="content">
         
            {currentPage === "Dashboard2" && <Dashboard2 />}
            {currentPage === "Recordings" && <Recordings />}
            {currentPage === "Community" && <Community />}
            {currentPage === "Map" && <HeatMapView />}
            {currentPage === "LocationView" && <LocationView />}
          </div>
        </>
    ) : (
      <Login onLogin={handleLogin} />
    )}
  </div>


   
  );
}

export default App;
